module.exports = __webpack_public_path__ + "img/iphone-hero-plus-04.58ce49dd.png";